import api from '@/api';
import { API_BASE_URL } from '..';
import { ManagerialIncomeRequest } from './Managerial.types';

const baseUrl = `${API_BASE_URL}/Managerial`;

export async function generateManagerialIncome(
  params?: ManagerialIncomeRequest,
) {
  const result = (await api.getReport(`${baseUrl}/Income`, params)) as unknown;

  return result as BlobPart;
}
